import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { FaGlobe } from "react-icons/fa";
import { Link } from "react-router-dom";

const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: "smooth" });
};

// Spinner Component
const Spinner = () => (
  <div className="flex items-center justify-center min-h-screen bg-black bg-opacity-90">
    <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-yellow-400 border-solid"></div>
  </div>
);

const AboutUs = ({ language }) => {
  const [data, setData] = useState(null);

  const [imageLoaded, setImageLoaded] = useState(false);

  useEffect(() => {
    const img = new Image();
    img.src = "/image/bg/Astrology__books.webp"; // Ensure correct path
    img.onload = () => setImageLoaded(true);
  }, []);

  useEffect(() => {
    fetch("/data.json")
      .then((response) => response.json())
      .then((json) => setData(json))
      .catch((error) => console.error("Error loading data:", error));
  }, []);

  if (!data) {
    return <Spinner />;
  }

  return (
    <>
    <Helmet>
        <title>Astro-MahaMaya </title>
        <meta name="description" content="Astromahamaya is a trusted astrology service offering life-changing guidance through experienced Vedic astrologers. Our mission is to help you improve your life with astrology, whether you face career challenges, relationship issues, or personal growth questions. With accurate astrological solutions and personalized consultations, we provide the clarity you need to navigate life’s complexities."/>
        <meta name="keywords" content="How can astrology improve my life?, Trusted astrologers for guidance, Astrology for life problems, Best Vedic astrology services" />
        <meta property="og:title" content="About Us" />
        <meta property="og:description" content="Discover personalized astrology services. || AstroMahaMaya" />
        <meta property="og:url" content="https://astromahamaya.com/#about-us" />
      </Helmet>
   

    <div
      id="about-us" className="relative bg-white bg-opacity-60 text-center shadow-xl mt-3 transition-opacity duration-500"
      // style={{
      //   backgroundImage: imageLoaded ? "url('/image/bg/Astrology__books.webp')" : "none",
      //   backgroundSize: "cover",
      //   backgroundPosition: "center",
      //   backgroundAttachment: "fixed", // ✅ Fixes zoom issue
      // }}
    >
        {/* Dark Overlay */}
        <div className="absolute inset-0 bg-yellow-50 bg-opacity-80"></div>
        
      {/* Content Wrapper */}
      <div className="relative z-10 p-6 sm:p-12 max-w-4xl mx-auto bg-yellow-50 opacity-80">
        {/* Language Switch Button */}
        {/* <button
          onClick={() => setLanguage(language === "hindi" ? "english" : "hindi")}
          className="absolute top-4 right-4 bg-black hover:bg-black text-white font-bold py-2 px-4 rounded-full shadow-lg transition-all duration-300 flex items-center gap-2"
        >
          <FaGlobe className="text-lg" /> {language === "hindi" ? "English" : "हिंदी"}
        </button> */}

        {/* Title */}
        <h2 className="text-4xl md:text-5xl font-bold text-black mt-8 sm:mt-0">
          {data.aboutus[language]}
        </h2>

        {/* Description */}
        <p className="text-lg sm:text-xl text-gray-600 mt-4 sm:mt-6 leading-relaxed">
          {data.aboutusDescription[language]}
        </p>

        {/* Services */}
        <h3 className="text-2xl font-semibold text-yellow-800 underline mt-6 sm:mt-8">
          {data.servicesTitle[language]}
        </h3>
        <ul className="grid grid-cols-2 gap-4 text-lg text-gray-600 mt-4">
          {data.services.map((service, index) => (
            <li key={index}>{service.title[language]}</li>
          ))}
        </ul>

        {/* Explore Services Button */}
        <Link to="/services">
          <button
            className="mt-8 px-6 py-3 bg-yellow-500 text-black font-bold rounded-lg hover:bg-yellow-600 transition-all duration-300"
            onClick={scrollToTop}
          >
            {language === "hindi" ? "सभी सेवाएँ विस्तारसे देखें" : "Explore All Services in Detail"}
          </button>
        </Link>
      </div>
    </div>
    </>
  );
};

export default AboutUs;
